import { type Static, Type } from '@sinclair/typebox';

export const ArticleSchema = Type.Object({
	id: Type.Number(),
	attributes: Type.Object({
		title: Type.String(),
		handle: Type.String(),
		description: Type.String(),
		summary_html: Type.Union([Type.String(), Type.Null()]),
		body_html: Type.String(),
		image_alt: Type.String(),
		image: Type.Object({
			data: Type.Array(
				Type.Object({
					id: Type.Number(),
					attributes: Type.Object({
						name: Type.String(),
						alternativeText: Type.Union([Type.String(), Type.Null()]),
						caption: Type.Union([Type.String(), Type.Null()]),
						width: Type.Number(),
						height: Type.Number(),
						formats: Type.Object({
							large: Type.Optional(
								Type.Object({
									url: Type.String(),
									width: Type.Number(),
									height: Type.Number(),
								}),
							),
							small: Type.Optional(
								Type.Object({
									url: Type.String(),
									width: Type.Number(),
									height: Type.Number(),
								}),
							),
							medium: Type.Optional(
								Type.Object({
									url: Type.String(),
									width: Type.Number(),
									height: Type.Number(),
								}),
							),
							thumbnail: Type.Object({
								url: Type.String(),
								width: Type.Number(),
								height: Type.Number(),
							}),
						}),
						url: Type.String(),
					}),
				}),
			),
		}),
	}),
});
export const ArticleResponseSchema = Type.Object({
	data: Type.Array(ArticleSchema),
});

export const PaginatedArticleResponseSchema = Type.Object({
	data: Type.Array(ArticleSchema),
	meta: Type.Object({
		pagination: Type.Object({
			page: Type.Number(),
			pageSize: Type.Number(),
			pageCount: Type.Number(),
			total: Type.Number(),
		}),
	}),
});

export type Article = Static<typeof ArticleSchema>;

export type PaginatedArticles = Static<typeof PaginatedArticleResponseSchema>;

export type ExpandedArticle = Article & {
	handle: string;
	publishedAt: string;
};

export type ArticleResponse = Static<typeof ArticleResponseSchema>;

export const BlogSchema = Type.Object({
	id: Type.Number(),
	attributes: Type.Object({
		title: Type.String(),
		handle: Type.String(),
		publishedAt: Type.String(),
		articles: Type.Object({
			data: Type.Array(ArticleSchema),
		}),
	}),
});

export const BlogResponseSchema = Type.Object({
	data: Type.Array(BlogSchema),
	meta: Type.Object({
		pagination: Type.Object({
			page: Type.Number(),
			pageSize: Type.Number(),
			pageCount: Type.Number(),
			total: Type.Number(),
		}),
	}),
});

export type Blog = Static<typeof BlogSchema>;
export type BlogResponse = Static<typeof BlogResponseSchema>;
